import { graphql } from 'relay-runtime';

export const getPracticeProblemsSession = graphql`
  query PracticeProblemsSessionQuery($skillId: ID!, $studentId: ID!, $skip: Boolean!) {
    learnosityPracticeProblemsSession(skillId: $skillId, studentId: $studentId) @skip(if: $skip) {
      sessionId
      isActive
    }
  }
`;

export const upsertPracticeProblemsSession = graphql`
  mutation PracticeProblemsSessionMutation($input: UpsertLearnosityPracticeProblemsSessionInput!) {
    upsertLearnosityPracticeProblemsSession(input: $input) {
      learnosityPracticeProblemsSessionNode {
        id
        sessionId
      }
    }
  }
`;
